import { Col } from 'antd';
import CustomModal from '../Antd/Modal';
import CustomSpin from '../Antd/Spin';

export default function LoadingModal(props) {
	return (
		<CustomModal open={props?.visible} closable={false} footer={null} centered maskClosable={false} destroyOnClose>
			<Col style={{ height: '20vh' }}>
				<h2>Cargando</h2>
				<CustomSpin tip="Cargando..." size="large">
					<div style={{ padding: '50px' }} />
				</CustomSpin>
			</Col>
		</CustomModal>
	);
}
